export default "__VITE_ASSET__BhicNmKa__"